import { AUDIO_PROVIDER } from './chunk-NGH45AL6.js';
import { HLS_PROVIDER, SET_AUTO_QUALITY, ENABLE_AUTO_QUALITY, coerceToError } from './chunk-SHL2VI7U.js';
import { VIDEO_PROVIDER } from './chunk-EMXARJAH.js';
import { LIST_READONLY, LIST_ADD, LIST_REMOVE, LIST_ON_REMOVE, LIST_RESET, LIST_SET_READONLY, LIST_ON_RESET, LIST_ON_USER_SELECT, LIST_SELECT } from './chunk-JIIET4JM.js';
import { functionThrottle } from './chunk-JELAJF2G.js';
import { clampNumber } from './chunk-CVLY5S52.js';
import { canOrientScreen } from './chunk-KKTONNDY.js';
import { isTrackCaptionKind, ATTACH_VIDEO, TEXT_TRACK_NATIVE_HLS, TextTrack, TEXT_TRACK_CROSSORIGIN, TEXT_TRACK_CAN_LOAD, TEXT_TRACK_ON_MODE_CHANGE, TEXT_TRACK_NATIVE, TEXT_TRACK_UPDATE_ACTIVE_CUES } from './chunk-GHCUWWGF.js';
import { getRequestCredentials } from './chunk-IVW6GMZV.js';
import { setAttributeIfEmpty } from './chunk-Z6A4GYXE.js';
import { mediaContext, useMedia } from './chunk-ZIBTY3GT.js';
import { FocusVisibleController } from './chunk-LOFOQRT3.js';
import { __decorateClass } from './chunk-VPSTUDLO.js';
import { EventsTarget, DOMEvent, listenEvent, isArray, isUndefined, isNull, uppercaseFirstChar, setAttribute, camelToKebabCase, isKeyboardClick, deferredPromise, appendTriggerEvent, noop } from 'maverick.js/std';
import { defineProp, defineElement, prop, method, ComponentController, Component } from 'maverick.js/element';
import { StoreFactory, tick, signal, computed, effect, peek, onDispose, provideContext } from 'maverick.js';
import { parseResponse } from 'media-captions';

var _a;
var List = class extends EventsTarget {
  constructor() {
    super(...arguments);
    this.p = [];
    /* @internal */
    this[_a] = false;
  }
  get length() {
    return this.p.length;
  }
  get readonly() {
    return this[LIST_READONLY];
  }
  /**
   * Transform list to an array.
   */
  toArray() {
    return [...this.p];
  }
  [(_a = LIST_READONLY, Symbol.iterator)]() {
    return this.p.values();
  }
  /* @internal */
  [LIST_ADD](item, trigger) {
    const index = this.p.length;
    if (!("" + index in this)) {
      Object.defineProperty(this, index, {
        get() {
          return this.p[index];
        }
      });
    }
    if (this.p.includes(item))
      return;
    this.p.push(item);
    this.dispatchEvent(new DOMEvent("add", { detail: item, trigger }));
  }
  /* @internal */
  [LIST_REMOVE](item, trigger) {
    const index = this.p.indexOf(item);
    if (index >= 0) {
      this[LIST_ON_REMOVE]?.(item, trigger);
      this.p.splice(index, 1);
      this.dispatchEvent(new DOMEvent("remove", { detail: item, trigger }));
    }
  }
  /* @internal */
  [LIST_RESET](trigger) {
    for (const item of [...this.p])
      this[LIST_REMOVE](item, trigger);
    this.p = [];
    this[LIST_SET_READONLY](false, trigger);
    this[LIST_ON_RESET]?.();
  }
  /* @internal */
  [LIST_SET_READONLY](readonly, trigger) {
    if (this[LIST_READONLY] === readonly)
      return;
    this[LIST_READONLY] = readonly;
    this.dispatchEvent(new DOMEvent("readonly-change", { detail: readonly, trigger }));
  }
};

// ../../node_modules/.pnpm/fscreen@1.2.0/node_modules/fscreen/dist/fscreen.esm.js
var key = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
};
var webkit = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen"
];
var moz = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen"
];
var ms = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen"
];
var document2 = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {};
var vendor = "fullscreenEnabled" in document2 && Object.keys(key) || webkit[0] in document2 && webkit || moz[0] in document2 && moz || ms[0] in document2 && ms || [];
var fscreen = {
  requestFullscreen: function(element) {
    return element[vendor[key.requestFullscreen]]();
  },
  requestFullscreenFunction: function(element) {
    return element[vendor[key.requestFullscreen]];
  },
  get exitFullscreen() {
    return document2[vendor[key.exitFullscreen]].bind(document2);
  },
  get fullscreenPseudoClass() {
    return ":" + vendor[key.fullscreen];
  },
  addEventListener: function(type, handler, options) {
    return document2.addEventListener(vendor[key[type]], handler, options);
  },
  removeEventListener: function(type, handler, options) {
    return document2.removeEventListener(vendor[key[type]], handler, options);
  },
  get fullscreenEnabled() {
    return Boolean(document2[vendor[key.fullscreenEnabled]]);
  },
  set fullscreenEnabled(val) {
  },
  get fullscreenElement() {
    return document2[vendor[key.fullscreenElement]];
  },
  set fullscreenElement(val) {
  },
  get onfullscreenchange() {
    return document2[("on" + vendor[key.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(handler) {
    return document2[("on" + vendor[key.fullscreenchange]).toLowerCase()] = handler;
  },
  get onfullscreenerror() {
    return document2[("on" + vendor[key.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(handler) {
    return document2[("on" + vendor[key.fullscreenerror]).toLowerCase()] = handler;
  }
};
var fscreen_esm_default = fscreen;
var CAN_FULLSCREEN = fscreen_esm_default.fullscreenEnabled;
var FullscreenController = class extends ComponentController {
  constructor() {
    super(...arguments);
    /**
     * Tracks whether we're the active fullscreen event listener. Fullscreen events can only be
     * listened to globally on the document so we need to know if they relate to the current host
     * element or not.
     */
    this.La = false;
    this.Cb = false;
  }
  get active() {
    return this.Cb;
  }
  get supported() {
    return CAN_FULLSCREEN;
  }
  onConnect() {
    listenEvent(fscreen_esm_default, "fullscreenchange", this.ge.bind(this));
    listenEvent(fscreen_esm_default, "fullscreenerror", this.cb.bind(this));
  }
  async onDisconnect() {
    if (CAN_FULLSCREEN)
      await this.exit();
  }
  ge(event) {
    const active = isFullscreen(this.el);
    if (active === this.Cb)
      return;
    if (!active)
      this.La = false;
    this.Cb = active;
    this.dispatch("fullscreen-change", { detail: active, trigger: event });
  }
  cb(event) {
    if (!this.La)
      return;
    this.dispatch("fullscreen-error", { detail: null, trigger: event });
    this.La = false;
  }
  async enter() {
    try {
      this.La = true;
      if (!this.el || isFullscreen(this.el))
        return;
      assertFullscreenAPI();
      return fscreen_esm_default.requestFullscreen(this.el);
    } catch (error) {
      this.La = false;
      throw error;
    }
  }
  async exit() {
    if (!this.el || !isFullscreen(this.el))
      return;
    assertFullscreenAPI();
    return fscreen_esm_default.exitFullscreen();
  }
};
function canFullscreen() {
  return CAN_FULLSCREEN;
}
function isFullscreen(host) {
  if (fscreen_esm_default.fullscreenElement === host)
    return true;
  try {
    return host.matches(
      // @ts-expect-error - `fullscreenPseudoClass` is missing from `@types/fscreen`.
      fscreen_esm_default.fullscreenPseudoClass
    );
  } catch (error) {
    return false;
  }
}
function assertFullscreenAPI() {
  if (CAN_FULLSCREEN)
    return;
  throw Error(
    "[vidstack] no fullscreen API"
  );
}
var CAN_ORIENT_SCREEN = canOrientScreen();
var ScreenOrientationController = class extends ComponentController {
  constructor() {
    super(...arguments);
    this.D = getScreenOrientation();
    this.ua = false;
  }
  /**
   * The current screen orientation. It will return `undefined` if the Screen Orientation API
   * is not available.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get orientation() {
    return this.D;
  }
  /**
   * Whether the screen orientation is currently locked.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get locked() {
    return this.ua;
  }
  /**
   * Whether the native Screen Orientation API is available.
   */
  get supported() {
    return CAN_ORIENT_SCREEN;
  }
  onConnect() {
    if (CAN_ORIENT_SCREEN) {
      listenEvent(screen.orientation, "change", this.he.bind(this));
    }
  }
  async onDisconnect() {
    if (CAN_ORIENT_SCREEN && this.ua)
      await this.unlock();
  }
  he(event) {
    this.D = getScreenOrientation();
    this.dispatch("orientation-change", {
      detail: {
        orientation: this.D,
        lock: this.Db
      },
      trigger: event
    });
  }
  /**
   * Locks the orientation of the screen to the desired orientation type using the
   * Screen Orientation API.
   *
   * @param lockType - The screen lock orientation type.
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async lock(lockType) {
    if (this.ua)
      return;
    assertScreenOrientationAPI();
    await screen.orientation.lock(lockType);
    this.ua = true;
    this.Db = lockType;
  }
  /**
   * Unlocks the orientation of the screen to it's default state using the Screen Orientation
   * API. This method will throw an error if the API is unavailable.
   *
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async unlock() {
    if (!this.ua)
      return;
    assertScreenOrientationAPI();
    this.Db = void 0;
    await screen.orientation.unlock();
    this.ua = false;
  }
};
function assertScreenOrientationAPI() {
  if (!CAN_ORIENT_SCREEN)
    return;
  throw Error(
    "[vidstack] no orientation API"
  );
}
function getScreenOrientation() {
  return window.screen?.orientation?.type;
}

// src/player/core/providers/type-check.ts
function isAudioProvider(provider) {
  return !!provider?.[AUDIO_PROVIDER];
}
function isVideoProvider(provider) {
  return !!provider?.[VIDEO_PROVIDER];
}
function isHLSProvider(provider) {
  return !!provider?.[HLS_PROVIDER];
}
function isHTMLAudioElement(element) {
  return element instanceof HTMLAudioElement;
}
function isHTMLVideoElement(element) {
  return element instanceof HTMLVideoElement;
}
function isHTMLMediaElement(element) {
  return isHTMLAudioElement(element) || isHTMLVideoElement(element);
}
var MEDIA_KEY_SHORTCUTS = {
  togglePaused: "k Space",
  toggleMuted: "m",
  toggleFullscreen: "f",
  togglePictureInPicture: "i",
  toggleCaptions: "c",
  seekBackward: "ArrowLeft",
  seekForward: "ArrowRight",
  volumeUp: "ArrowUp",
  volumeDown: "ArrowDown"
};
var MODIFIER_KEYS = /* @__PURE__ */ new Set(["Shift", "Alt", "Meta", "Control"]);
var BUTTON_SELECTORS = 'button, [role="button"]';
var IGNORE_SELECTORS = 'input, textarea, select, [contenteditable], [role^="menuitem"]';
var MediaKeyboardController = class extends ComponentController {
  constructor(instance, _media) {
    super(instance);
    this.a = _media;
    this.ya = null;
  }
  onConnect() {
    effect(this.cf.bind(this));
  }
  cf() {
    const { keyDisabled, keyTarget } = this.$props;
    if (keyDisabled())
      return;
    const target = keyTarget() === "player" ? this.el : document, $active = signal(false);
    if (target === this.el) {
      this.listen("focusin", () => $active.set(true));
      this.listen("focusout", (event) => {
        if (!this.el.contains(event.target))
          $active.set(false);
      });
    } else {
      if (!peek($active))
        $active.set(document.querySelector("media-player") === this.el);
      listenEvent(document, "focusin", (event) => {
        const activePlayer = event.composedPath().find((el) => el instanceof Element && el.localName === "media-player");
        if (activePlayer !== void 0)
          $active.set(this.el === activePlayer);
      });
    }
    effect(() => {
      if (!$active())
        return;
      listenEvent(target, "keyup", this.Ua.bind(this));
      listenEvent(target, "keydown", this.Va.bind(this));
      listenEvent(target, "keydown", this.df.bind(this), { capture: true });
    });
  }
  Ua(event) {
    const focused = document.activeElement, sliderFocused = focused?.hasAttribute("data-media-slider");
    if (!event.key || !this.$store.canSeek() || sliderFocused || focused?.matches(IGNORE_SELECTORS)) {
      return;
    }
    const method2 = this.Ub(event);
    if (method2?.startsWith("seek")) {
      event.preventDefault();
      event.stopPropagation();
      if (this.ya) {
        this.hd(event);
        this.ya = null;
      } else {
        this.a.remote.seek(this.jb, event);
        this.jb = void 0;
      }
    }
    if (method2?.startsWith("volume")) {
      const volumeSlider = this.el.querySelector("media-volume-slider");
      volumeSlider?.dispatchEvent(new DOMEvent("keyup", { trigger: event }));
    }
  }
  Va(event) {
    if (!event.key || MODIFIER_KEYS.has(event.key))
      return;
    const focused = document.activeElement;
    if (focused?.matches(IGNORE_SELECTORS) || isKeyboardClick(event) && focused?.matches(BUTTON_SELECTORS)) {
      return;
    }
    const sliderFocused = focused?.hasAttribute("data-media-slider"), method2 = this.Ub(event);
    if (!method2 && /[0-9]/.test(event.key) && !sliderFocused) {
      event.preventDefault();
      event.stopPropagation();
      this.a.remote.seek(this.$store.duration() / 10 * Number(event.key), event);
      return;
    }
    if (!method2 || /volume|seek/.test(method2) && sliderFocused)
      return;
    event.preventDefault();
    event.stopPropagation();
    switch (method2) {
      case "seekForward":
      case "seekBackward":
        this.aa(event, method2);
        break;
      case "volumeUp":
      case "volumeDown":
        const volumeSlider = this.el.querySelector("media-volume-slider");
        if (volumeSlider) {
          volumeSlider.dispatchEvent(new DOMEvent("keydown", { trigger: event }));
        } else {
          const value = event.shiftKey ? 0.1 : 0.05;
          this.a.remote.changeVolume(
            this.$store.volume() + (method2 === "volumeUp" ? +value : -value),
            event
          );
        }
        break;
      case "toggleFullscreen":
        this.a.remote.toggleFullscreen("prefer-media", event);
        break;
      default:
        this.a.remote[method2]?.(event);
    }
  }
  df(event) {
    if (isHTMLMediaElement(event.target) && this.Ub(event)) {
      event.preventDefault();
    }
  }
  Ub(event) {
    const keyShortcuts = {
      ...this.$props.keyShortcuts(),
      ...this.a.ariaKeys
    };
    return Object.keys(keyShortcuts).find(
      (method2) => keyShortcuts[method2].split(" ").some(
        (keys) => replaceSymbolKeys(keys).replace(/Control/g, "Ctrl").split("+").every(
          (key2) => MODIFIER_KEYS.has(key2) ? event[key2.toLowerCase() + "Key"] : event.key === key2.replace("Space", " ")
        )
      )
    );
  }
  ef(event, type) {
    const seekBy = event.shiftKey ? 10 : 5;
    return this.jb = Math.max(
      0,
      Math.min(
        (this.jb ?? this.$store.currentTime()) + (type === "seekForward" ? +seekBy : -seekBy),
        this.$store.duration()
      )
    );
  }
  hd(event) {
    this.ya?.dispatchEvent(new DOMEvent(event.type, { trigger: event }));
  }
  aa(event, type) {
    if (!this.$store.canSeek())
      return;
    if (!this.ya)
      this.ya = this.el.querySelector("media-time-slider");
    if (this.ya) {
      this.hd(event);
    } else {
      this.a.remote.seeking(this.ef(event, type), event);
    }
  }
};
var SYMBOL_KEY_MAP = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"];
function replaceSymbolKeys(key2) {
  return key2.replace(/Shift\+(\d)/g, (_, num) => SYMBOL_KEY_MAP[num - 1]);
}
var mediaPlayerProps = {
  autoplay: false,
  aspectRatio: defineProp({
    value: null,
    type: {
      from(value) {
        if (!value)
          return null;
        if (!value.includes("/"))
          return +value;
        const [width, height] = value.split("/").map(Number);
        return +(width / height).toFixed(4);
      }
    }
  }),
  controls: false,
  currentTime: 0,
  crossorigin: null,
  fullscreenOrientation: void 0,
  load: "visible",
  logLevel: "silent",
  loop: false,
  muted: false,
  paused: true,
  playsinline: false,
  playbackRate: 1,
  poster: "",
  preload: "metadata",
  preferNativeHLS: defineProp({
    value: false,
    attribute: "prefer-native-hls"
  }),
  src: "",
  userIdleDelay: 2e3,
  viewType: "unknown",
  streamType: "unknown",
  volume: 1,
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  keyDisabled: false,
  keyTarget: "player",
  keyShortcuts: MEDIA_KEY_SHORTCUTS,
  title: "",
  thumbnails: null,
  textTracks: defineProp({
    value: [],
    attribute: false
  })
};
var TimeRange = class {
  get length() {
    return this.za.length;
  }
  constructor(start, end) {
    if (isArray(start)) {
      this.za = start;
    } else if (!isUndefined(start) && !isUndefined(end)) {
      this.za = [[start, end]];
    } else {
      this.za = [];
    }
  }
  start(index) {
    return this.za[index][0] ?? Infinity;
  }
  end(index) {
    return this.za[index][1] ?? Infinity;
  }
};
function getTimeRangesStart(range) {
  if (!range.length)
    return null;
  let min = range.start(0);
  for (let i = 1; i < range.length; i++) {
    const value = range.start(i);
    if (value < min)
      min = value;
  }
  return min;
}
function getTimeRangesEnd(range) {
  if (!range.length)
    return null;
  let max = range.end(0);
  for (let i = 1; i < range.length; i++) {
    const value = range.end(i);
    if (value > max)
      max = value;
  }
  return max;
}
var MediaStoreFactory = new StoreFactory({
  audioTracks: [],
  audioTrack: null,
  autoplay: false,
  autoplayError: void 0,
  buffered: new TimeRange(),
  duration: 0,
  canLoad: false,
  canFullscreen: false,
  canPictureInPicture: false,
  canPlay: false,
  controls: false,
  crossorigin: null,
  poster: "",
  currentTime: 0,
  ended: false,
  error: void 0,
  fullscreen: false,
  loop: false,
  logLevel: "silent",
  mediaType: "unknown",
  muted: false,
  paused: true,
  played: new TimeRange(),
  playing: false,
  playsinline: false,
  pictureInPicture: false,
  preload: "metadata",
  playbackRate: 1,
  qualities: [],
  quality: null,
  autoQuality: false,
  canSetQuality: true,
  seekable: new TimeRange(),
  seeking: false,
  source: { src: "", type: "" },
  sources: [],
  started: false,
  title: "",
  textTracks: [],
  textTrack: null,
  thumbnails: null,
  thumbnailCues: [],
  volume: 1,
  waiting: false,
  get viewType() {
    return this.providedViewType !== "unknown" ? this.providedViewType : this.mediaType;
  },
  get streamType() {
    return this.providedStreamType !== "unknown" ? this.providedStreamType : this.inferredStreamType;
  },
  get currentSrc() {
    return this.source;
  },
  get bufferedStart() {
    return getTimeRangesStart(this.buffered) ?? 0;
  },
  get bufferedEnd() {
    return getTimeRangesEnd(this.buffered) ?? 0;
  },
  get seekableStart() {
    return getTimeRangesStart(this.seekable) ?? 0;
  },
  get seekableEnd() {
    return this.canPlay ? getTimeRangesEnd(this.seekable) ?? Infinity : 0;
  },
  get seekableWindow() {
    return Math.max(0, this.seekableEnd - this.seekableStart);
  },
  // ~~ user props ~~
  userIdle: false,
  userBehindLiveEdge: false,
  // ~~ live props ~~
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  get canSeek() {
    return /unknown|on-demand|:dvr/.test(this.streamType) && Number.isFinite(this.seekableWindow) && (!this.live || /:dvr/.test(this.streamType) && this.seekableWindow >= this.minLiveDVRWindow);
  },
  get live() {
    return this.streamType.includes("live") || !Number.isFinite(this.duration);
  },
  get liveEdgeStart() {
    return this.live && Number.isFinite(this.seekableEnd) ? Math.max(0, (this.liveSyncPosition ?? this.seekableEnd) - this.liveEdgeTolerance) : 0;
  },
  get liveEdge() {
    return this.live && (!this.canSeek || !this.userBehindLiveEdge && this.currentTime >= this.liveEdgeStart);
  },
  get liveEdgeWindow() {
    return this.live && Number.isFinite(this.seekableEnd) ? this.seekableEnd - this.liveEdgeStart : 0;
  },
  // ~~ internal props ~~
  autoplaying: false,
  canLoadPoster: null,
  providedViewType: "unknown",
  providedStreamType: "unknown",
  inferredStreamType: "unknown",
  liveSyncPosition: null
});
var DO_NOT_RESET_ON_SRC_CHANGE = /* @__PURE__ */ new Set([
  "autoplay",
  "canFullscreen",
  "canPictureInPicture",
  "canLoad",
  "controls",
  "fullscreen",
  "loop",
  "logLevel",
  "muted",
  "playsinline",
  "pictureInPicture",
  "preload",
  "poster",
  "source",
  "sources",
  "title",
  "textTracks",
  "textTrack",
  "thumbnails",
  "thumbnailCues",
  "volume",
  "canLoadPoster",
  "providedStreamType",
  "providedViewType"
]);
function softResetMediaStore($media) {
  MediaStoreFactory.reset($media, (prop2) => !DO_NOT_RESET_ON_SRC_CHANGE.has(prop2));
  tick();
}
var SELECTED = Symbol(0);
var SelectList = class extends List {
  get selected() {
    return this.p.find((item) => item.selected) ?? null;
  }
  get selectedIndex() {
    return this.p.findIndex((item) => item.selected);
  }
  /* @internal */
  [LIST_ON_REMOVE](item, trigger) {
    this[LIST_SELECT](item, false, trigger);
  }
  /* @internal */
  [LIST_ADD](item, trigger) {
    item[SELECTED] = false;
    Object.defineProperty(item, "selected", {
      get() {
        return this[SELECTED];
      },
      set: (selected) => {
        if (this.readonly)
          return;
        this[LIST_ON_USER_SELECT]?.();
        this[LIST_SELECT](item, selected);
      }
    });
    super[LIST_ADD](item, trigger);
  }
  /* @internal */
  [LIST_SELECT](item, selected, trigger) {
    if (selected === item[SELECTED])
      return;
    const prev = this.selected;
    item[SELECTED] = selected;
    const changed = !selected ? prev === item : prev !== item;
    if (changed) {
      if (prev)
        prev[SELECTED] = false;
      this.dispatchEvent(
        new DOMEvent("change", {
          detail: { prev, current: this.selected },
          trigger
        })
      );
    }
  }
};

// src/player/core/quality/video-quality.ts
var VideoQualityList = class extends SelectList {
  constructor() {
    super(...arguments);
    this.kb = false;
    /**
     * Configures quality switching:
     *
     * - `current`: Trigger an immediate quality level switch. This will abort the current fragment
     * request if any, flush the whole buffer, and fetch fragment matching with current position
     * and requested quality level.
     *
     * - `next`: Trigger a quality level switch for next fragment. This could eventually flush
     * already buffered next fragment.
     *
     * - `load`: Set quality level for next loaded fragment.
     *
     * @see {@link https://vidstack.io/docs/player/core-concepts/quality#switch}
     * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#quality-switch-control-api}
     */
    this.switch = "current";
  }
  /**
   * Whether automatic quality selection is enabled.
   */
  get auto() {
    return this.kb || this.readonly;
  }
  /* @internal */
  [(LIST_ON_USER_SELECT)]() {
    this[SET_AUTO_QUALITY](false);
  }
  /* @internal */
  [LIST_ON_RESET](trigger) {
    this[SET_AUTO_QUALITY](false, trigger);
  }
  /**
   * Request automatic quality selection (if supported). This will be a no-op if the list is
   * `readonly` as that already implies auto-selection.
   */
  autoSelect(trigger) {
    if (this.readonly || this.kb || !this[ENABLE_AUTO_QUALITY])
      return;
    this[ENABLE_AUTO_QUALITY]();
    this[SET_AUTO_QUALITY](true, trigger);
  }
  /* @internal */
  [SET_AUTO_QUALITY](auto, trigger) {
    if (this.kb === auto)
      return;
    this.kb = auto;
    this.dispatchEvent(
      new DOMEvent("auto-change", {
        detail: auto,
        trigger
      })
    );
  }
};
var STOP_IDLE_EVENTS = ["pointerup", "pointermove", "focus", "keydown", "playing"];
var MediaUserController = class extends ComponentController {
  constructor() {
    super(...arguments);
    this.Wb = 2e3;
    this.Aa = signal(false);
    this.Yb = signal(false);
    this.Zb = computed(() => this.Yb() || this.$store.paused());
  }
  /**
   * Whether the media user is currently idle.
   */
  get idling() {
    return this.Aa();
  }
  /**
   * Whether idle state tracking has been paused.
   */
  get idlePaused() {
    return this.Yb();
  }
  set idlePaused(paused) {
    this.Yb.set(paused);
  }
  /**
   * The amount of delay in milliseconds while media playback is progressing without user
   * activity to indicate an idle state.
   *
   * @defaultValue 2000
   */
  get idleDelay() {
    return this.Wb;
  }
  set idleDelay(newDelay) {
    this.Wb = newDelay;
  }
  onConnect() {
    effect(this._b.bind(this));
    effect(this.hf.bind(this));
  }
  onDisconnect() {
    this.Aa.set(false);
  }
  _b() {
    if (this.Zb())
      return;
    for (const eventType of STOP_IDLE_EVENTS) {
      listenEvent(this.el, eventType, this.jf.bind(this));
    }
  }
  hf() {
    window.clearTimeout(this.Vb);
    const idle = this.Aa() && !this.Zb();
    this.$store.userIdle.set(idle);
    this.dispatch("user-idle-change", {
      detail: idle,
      trigger: this.Xb
    });
    this.Xb = void 0;
  }
  jf(event) {
    if (this.Aa())
      this.Xb = event;
    this.Aa.set(false);
    window.clearTimeout(this.Vb);
    this.Vb = window.setTimeout(() => this.Aa.set(!peek(this.Zb)), this.Wb);
  }
};
var MediaRemoteControl = class {
  constructor(_logger) {
    this.Eb = _logger;
    this.ea = null;
    this.Wa = null;
    this.fc = -1;
  }
  /**
   * Set the target from which to dispatch media requests events from. The events should bubble
   * up from this target to the `<media-player>` element.
   *
   * @example
   * ```ts
   * const button = document.querySelector('button');
   * remote.setTarget(button);
   * ```
   */
  setTarget(target) {
    this.ea = target;
  }
  /**
   * Returns the current `<media-player>` element. This method will attempt to find the player by
   * searching up from either the given `target` or default target set via `remote.setTarget`.
   *
   * @example
   * ```ts
   * const player = remote.getPlayer();
   * ```
   */
  getPlayer(target) {
    if (this.Wa)
      return this.Wa;
    (target ?? this.ea)?.dispatchEvent(
      new DOMEvent("find-media-player", {
        detail: (player) => void (this.Wa = player),
        bubbles: true,
        composed: true
      })
    );
    return this.Wa;
  }
  /**
   * Set the current `<media-player>` element so the remote can support toggle methods such as
   * `togglePaused` as they rely on the current media state.
   */
  setPlayer(player) {
    this.Wa = player;
  }
  /**
   * Dispatch a request to start the media loading process. This will only work if the media
   * player has been initialized with a custom loading strategy `<media-player load="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#loading-strategies}
   */
  startLoading(trigger) {
    this.s("media-start-loading", trigger);
  }
  /**
   * Dispatch a request to begin/resume media playback.
   */
  play(trigger) {
    this.s("media-play-request", trigger);
  }
  /**
   * Dispatch a request to pause media playback.
   */
  pause(trigger) {
    this.s("media-pause-request", trigger);
  }
  /**
   * Dispatch a request to set the media volume to mute (0).
   */
  mute(trigger) {
    this.s("media-mute-request", trigger);
  }
  /**
   * Dispatch a request to unmute the media volume and set it back to it's previous state.
   */
  unmute(trigger) {
    this.s("media-unmute-request", trigger);
  }
  /**
   * Dispatch a request to enter fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/fullscreen#media-remote}
   */
  enterFullscreen(target, trigger) {
    this.s("media-enter-fullscreen-request", trigger, target);
  }
  /**
   * Dispatch a request to exit fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/fullscreen#media-remote}
   */
  exitFullscreen(target, trigger) {
    this.s("media-exit-fullscreen-request", trigger, target);
  }
  /**
   * Dispatch a request to enter picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/picture-in-picture#media-remote}
   */
  enterPictureInPicture(trigger) {
    this.s("media-enter-pip-request", trigger);
  }
  /**
   * Dispatch a request to exit picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/picture-in-picture#media-remote}
   */
  exitPictureInPicture(trigger) {
    this.s("media-exit-pip-request", trigger);
  }
  /**
   * Notify the media player that a seeking process is happening and to seek to the given `time`.
   */
  seeking(time, trigger) {
    this.s("media-seeking-request", trigger, time);
  }
  /**
   * Notify the media player that a seeking operation has completed and to seek to the given `time`.
   * This is generally called after a series of `remote.seeking()` calls.
   */
  seek(time, trigger) {
    this.s("media-seek-request", trigger, time);
  }
  seekToLiveEdge(trigger) {
    this.s("media-live-edge-request", trigger);
  }
  /**
   * Dispatch a request to update the media volume to the given `volume` level which is a value
   * between 0 and 1.
   *
   * @example
   * ```ts
   * remote.changeVolume(0); // 0%
   * remote.changeVolume(0.05); // 5%
   * remote.changeVolume(0.5); // 50%
   * remote.changeVolume(0.75); // 70%
   * remote.changeVolume(1); // 100%
   * ```
   */
  changeVolume(volume, trigger) {
    this.s("media-volume-change-request", trigger, Math.max(0, Math.min(1, volume)));
  }
  /**
   * Dispatch a request to change the current audio track.
   *
   * @example
   * ```ts
   * remote.changeAudioTrack(1); // track at index 1
   * ```
   */
  changeAudioTrack(index, trigger) {
    this.s("media-audio-track-change-request", trigger, index);
  }
  /**
   * Dispatch a request to change the video quality. The special value `-1` represents auto quality
   * selection.
   *
   * @example
   * ```ts
   * remote.changeQuality(-1); // auto
   * remote.changeQuality(1); // quality at index 1
   * ```
   */
  changeQuality(index, trigger) {
    this.s("media-quality-change-request", trigger, index);
  }
  /**
   * Dispatch a request to change the mode of the text track at the given index.
   *
   * @example
   * ```ts
   * remote.changeTextTrackMode(1, 'showing'); // track at index 1
   * ```
   */
  changeTextTrackMode(index, mode, trigger) {
    this.s("media-text-track-change-request", trigger, {
      index,
      mode
    });
  }
  /**
   * Dispatch a request to change the media playback rate.
   *
   * @example
   * ```ts
   * remote.changePlaybackRate(0.5); // Half the normal speed
   * remote.changePlaybackRate(1); // Normal speed
   * remote.changePlaybackRate(1.5); // 50% faster than normal
   * remote.changePlaybackRate(2); // Double the normal speed
   * ```
   */
  changePlaybackRate(rate, trigger) {
    this.s("media-rate-change-request", trigger, rate);
  }
  /**
   * Dispatch a request to resume user idle tracking. Refer to {@link MediaRemoteControl.pauseUserIdle}
   * for more information.
   */
  resumeUserIdle(trigger) {
    this.s("media-resume-user-idle-request", trigger);
  }
  /**
   * Dispatch a request to pause user idle tracking. Pausing tracking will result in the `user-idle`
   * attribute and state being `false` until `remote.resumeUserIdle()` is called. This method
   * is generally used when building custom controls and you'd like to prevent the UI from
   * dissapearing.
   *
   * @example
   * ```ts
   * // Prevent user idling while menu is being interacted with.
   * function onSettingsOpen() {
   *   remote.pauseUserIdle();
   * }
   *
   * function onSettingsClose() {
   *   remote.resumeUserIdle();
   * }
   * ```
   */
  pauseUserIdle(trigger) {
    this.s("media-pause-user-idle-request", trigger);
  }
  /**
   * Dispatch a request to load and show the native poster element.
   */
  showPoster(trigger) {
    this.s("media-show-poster-request", trigger);
  }
  /**
   * Dispatch a request to prevent loading and to hide the native poster element.
   */
  hidePoster(trigger) {
    this.s("media-hide-poster-request", trigger);
  }
  /**
   * Dispatch a request to toggle the media playback state.
   */
  togglePaused(trigger) {
    const player = this.getPlayer(trigger?.target);
    if (!player) {
      return;
    }
    if (player.state.paused)
      this.play(trigger);
    else
      this.pause(trigger);
  }
  /**
   * Dispatch a request to toggle the media muted state.
   */
  toggleMuted(trigger) {
    const player = this.getPlayer(trigger?.target);
    if (!player) {
      return;
    }
    if (player.state.muted)
      this.unmute(trigger);
    else
      this.mute(trigger);
  }
  /**
   * Dispatch a request to toggle the media fullscreen state.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/fullscreen#media-remote}
   */
  toggleFullscreen(target, trigger) {
    const player = this.getPlayer(trigger?.target);
    if (!player) {
      return;
    }
    if (player.state.fullscreen)
      this.exitFullscreen(target, trigger);
    else
      this.enterFullscreen(target, trigger);
  }
  /**
   * Dispatch a request to toggle the media picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/picture-in-picture#media-remote}
   */
  togglePictureInPicture(trigger) {
    const player = this.getPlayer(trigger?.target);
    if (!player) {
      return;
    }
    if (player.state.pictureInPicture)
      this.exitPictureInPicture(trigger);
    else
      this.enterPictureInPicture(trigger);
  }
  /**
   * Dispatch a request to toggle the current captions mode.
   */
  toggleCaptions(trigger) {
    const player = this.getPlayer(trigger?.target);
    if (!player) {
      return;
    }
    const tracks = player.state.textTracks, track = player.state.textTrack;
    if (track) {
      const index = tracks.indexOf(track);
      this.changeTextTrackMode(index, "disabled", trigger);
      this.fc = index;
    } else {
      let index = this.fc;
      if (!tracks[index] || !isTrackCaptionKind(tracks[index])) {
        index = -1;
      }
      if (index === -1) {
        index = tracks.findIndex((track2) => isTrackCaptionKind(track2) && track2.default);
      }
      if (index === -1) {
        index = tracks.findIndex((track2) => isTrackCaptionKind(track2));
      }
      if (index >= 0)
        this.changeTextTrackMode(index, "showing", trigger);
      this.fc = -1;
    }
  }
  s(type, trigger, detail) {
    const request = new DOMEvent(type, {
      bubbles: true,
      composed: true,
      detail,
      trigger
    });
    const target = trigger?.target === document || trigger?.target === window || trigger?.target === document.body ? this.ea ?? this.getPlayer() : trigger?.target ?? this.ea;
    target?.dispatchEvent(request);
  }
  Ih(method2) {
  }
};

// src/player/core/tracks/audio-tracks.ts
var AudioTrackList = class extends SelectList {
  getById(id) {
    if (id === "")
      return null;
    return this.p.find((track) => track.id === id) ?? null;
  }
};

// src/player/core/tracks/text/render/native-text-renderer.ts
var NativeTextRenderer = class {
  constructor() {
    this.priority = 0;
    this.wd = true;
    this.k = null;
    this.m = null;
    this.Xa = /* @__PURE__ */ new Set();
  }
  canRender() {
    return true;
  }
  attach(video) {
    this.k = video;
    if (!video.crossOrigin)
      video.crossOrigin = "anonymous";
    video.textTracks.onchange = this.o.bind(this);
  }
  addTrack(track) {
    this.Xa.add(track);
    this.Gf(track);
  }
  removeTrack(track) {
    track[TEXT_TRACK_NATIVE]?.remove?.();
    track[TEXT_TRACK_NATIVE] = null;
    this.Xa.delete(track);
  }
  changeTrack(track) {
    const prev = this.m?.[TEXT_TRACK_NATIVE], current = track?.[TEXT_TRACK_NATIVE];
    if (prev && this.m !== track)
      prev.track.mode = "disabled";
    if (current)
      current.track.mode = "showing";
    this.m = track;
  }
  setDisplay(display) {
    this.wd = display;
  }
  detach() {
    if (this.k)
      this.k.textTracks.onchange = null;
    for (const track of this.Xa)
      this.removeTrack(track);
    this.Xa.clear();
    this.k = null;
    this.m = null;
  }
  Gf(track) {
    if (!this.k)
      return;
    const el = track[TEXT_TRACK_NATIVE] ??= this.Hf(track);
    if (el instanceof HTMLElement)
      this.k.append(el);
  }
  Hf(track) {
    const el = document.createElement("track");
    el.src = "https://cdn.jsdelivr.net/npm/vidstack/empty.vtt";
    el.id = track.id;
    el.label = track.label;
    el.kind = track.kind;
    el.default = track.default;
    track.language && (el.srclang = track.language);
    return el;
  }
  If(track, native) {
    if (native.cues?.length)
      return;
    for (const cue of track.cues)
      native.addCue(cue);
  }
  o(event) {
    for (const track of this.Xa) {
      const nativeTrack = track[TEXT_TRACK_NATIVE]?.track;
      if (!nativeTrack)
        continue;
      if (!this.wd) {
        nativeTrack.mode = "disabled";
        continue;
      }
      if (nativeTrack.mode === "showing") {
        this.If(track, nativeTrack);
        track.setMode("showing", event);
      } else if (track.mode === "showing") {
        track.setMode("disabled", event);
      }
    }
  }
};

// src/player/core/tracks/text/render/text-renderer.ts
var TextRenderers = class {
  constructor(_media) {
    this.a = _media;
    this.k = null;
    this.nb = [];
    this.xd = false;
    this.O = null;
    this.ja = null;
    const textTracks = _media.textTracks;
    this.gc = textTracks;
    effect(this.Jf.bind(this));
    onDispose(this.yd.bind(this));
    listenEvent(textTracks, "add", this.Mb.bind(this));
    listenEvent(textTracks, "remove", this.Kf.bind(this));
    listenEvent(textTracks, "mode-change", this.J.bind(this));
  }
  Jf() {
    const { $store, $iosControls } = this.a;
    this.xd = $store.controls() || $iosControls();
    this.J();
  }
  add(renderer) {
    this.nb.push(renderer);
    this.J();
  }
  remove(renderer) {
    renderer.detach();
    this.nb.splice(this.nb.indexOf(renderer), 1);
    this.J();
  }
  /* @internal */
  [ATTACH_VIDEO](video) {
    requestAnimationFrame(() => {
      this.k = video;
      if (video) {
        this.O = new NativeTextRenderer();
        this.O.attach(video);
        for (const track of this.gc)
          this.zd(track);
      }
      this.J();
    });
  }
  zd(track) {
    if (!isTrackCaptionKind(track))
      return;
    this.O?.addTrack(track);
  }
  Lf(track) {
    if (!isTrackCaptionKind(track))
      return;
    this.O?.removeTrack(track);
  }
  Mb(event) {
    this.zd(event.detail);
  }
  Kf(event) {
    this.Lf(event.detail);
  }
  J() {
    if (!this.k) {
      this.yd();
      return;
    }
    const currentTrack = this.gc.selected;
    if (this.xd || currentTrack?.[TEXT_TRACK_NATIVE_HLS]) {
      this.ja?.changeTrack(null);
      this.O.setDisplay(true);
      this.O.changeTrack(currentTrack);
      return;
    }
    this.O.setDisplay(false);
    this.O.changeTrack(null);
    if (!currentTrack) {
      this.ja?.changeTrack(null);
      return;
    }
    const customRenderer = this.nb.sort((a, b) => a.priority - b.priority).find((loader) => loader.canRender(currentTrack));
    if (this.ja !== customRenderer) {
      this.ja?.detach();
      customRenderer?.attach(this.k);
      this.ja = customRenderer ?? null;
    }
    customRenderer?.changeTrack(currentTrack);
  }
  yd() {
    this.O?.detach();
    this.O = null;
    this.ja?.detach();
    this.ja = null;
  }
};
var TextTrackList = class extends List {
  constructor() {
    super(...arguments);
    this.wa = false;
    this.ob = {};
    this.Ad = this.ka.bind(this);
  }
  get selected() {
    const track = this.p.find((t) => t.mode === "showing" && isTrackCaptionKind(t));
    return track ?? null;
  }
  add(init, trigger) {
    const isTrack = init instanceof TextTrack, track = isTrack ? init : new TextTrack(init);
    if (this.ob[init.kind] && init.default)
      delete init.default;
    track.addEventListener("mode-change", this.Ad);
    this[LIST_ADD](track, trigger);
    track[TEXT_TRACK_CROSSORIGIN] = this[TEXT_TRACK_CROSSORIGIN];
    if (this.wa)
      track[TEXT_TRACK_CAN_LOAD]();
    if (init.default) {
      this.ob[init.kind] = track;
      track.mode = "showing";
    }
    return this;
  }
  remove(track, trigger) {
    if (!this.p.includes(track))
      return;
    if (track === this.ob[track.kind])
      delete this.ob[track.kind];
    track.mode = "disabled";
    track[TEXT_TRACK_ON_MODE_CHANGE] = null;
    track.removeEventListener("mode-change", this.Ad);
    this[LIST_REMOVE](track, trigger);
    return this;
  }
  clear(trigger) {
    for (const track of this.p)
      this.remove(track, trigger);
    return this;
  }
  getById(id) {
    return this.p.find((track) => track.id === id) ?? null;
  }
  getByKind(kind) {
    const kinds = Array.isArray(kind) ? kind : [kind];
    return this.p.filter((track) => kinds.includes(track.kind));
  }
  /* @internal */
  [(TEXT_TRACK_CAN_LOAD)]() {
    if (this.wa)
      return;
    for (const track of this.p)
      track[TEXT_TRACK_CAN_LOAD]();
    this.wa = true;
  }
  ka(event) {
    const track = event.detail;
    if (track.mode === "showing") {
      const kinds = isTrackCaptionKind(track) ? ["captions", "subtitles"] : [track.kind];
      for (const t of this.p) {
        if (t.mode === "showing" && t != track && kinds.includes(t.kind)) {
          t.mode = "disabled";
        }
      }
    }
    this.dispatchEvent(
      new DOMEvent("mode-change", {
        detail: event.detail,
        trigger: event
      })
    );
  }
};
var RequestQueue = class {
  constructor() {
    this.Oa = false;
    this.Hb = deferredPromise();
    this.f = /* @__PURE__ */ new Map();
  }
  /**
   * The number of callbacks that are currently in queue.
   */
  get me() {
    return this.f.size;
  }
  /**
   * Whether items in the queue are being served immediately, otherwise they're queued to
   * be processed later.
   */
  get Dh() {
    return this.Oa;
  }
  /**
   * Waits for the queue to be flushed (ie: start serving).
   */
  async Eh() {
    if (this.Oa)
      return;
    await this.Hb.promise;
  }
  /**
   * Queue the given `callback` to be invoked at a later time by either calling the `serve()` or
   * `start()` methods. If the queue has started serving (i.e., `start()` was already called),
   * then the callback will be invoked immediately.
   *
   * @param key - Uniquely identifies this callback so duplicates are ignored.
   * @param callback - The function to call when this item in the queue is being served.
   */
  l(key2, callback) {
    if (this.Oa) {
      callback();
      return;
    }
    this.f.delete(key2);
    this.f.set(key2, callback);
  }
  /**
   * Invokes the callback with the given `key` in the queue (if it exists).
   */
  Ib(key2) {
    this.f.get(key2)?.();
    this.f.delete(key2);
  }
  /**
   * Flush all queued items and start serving future requests immediately until `stop()` is called.
   */
  eb() {
    this.Tc();
    this.Oa = true;
    if (this.f.size > 0)
      this.Tc();
  }
  /**
   * Stop serving requests, they'll be queued until you begin processing again by calling `start()`.
   */
  fa() {
    this.Oa = false;
  }
  /**
   * Stop serving requests, empty the request queue, and release any promises waiting for the
   * queue to flush.
   */
  ne() {
    this.fa();
    this.f.clear();
    this.Uc();
  }
  Tc() {
    for (const key2 of this.f.keys())
      this.Ib(key2);
    this.Uc();
  }
  Uc() {
    this.Hb.resolve();
    this.Hb = deferredPromise();
  }
};

// src/player/core/api/media-attrs.ts
var MEDIA_ATTRIBUTES = [
  "autoplay",
  "autoplayError",
  "canFullscreen",
  "canPictureInPicture",
  "canLoad",
  "canPlay",
  "canSeek",
  "ended",
  "error",
  "fullscreen",
  "loop",
  "live",
  "liveEdge",
  "mediaType",
  "muted",
  "paused",
  "pictureInPicture",
  "playing",
  "playsinline",
  "seeking",
  "started",
  "streamType",
  "userIdle",
  "viewType",
  "waiting"
];
var MediaLoadController = class extends ComponentController {
  constructor(instance, _callback) {
    super(instance);
    this.ga = _callback;
  }
  async onAttach(el) {
    const load = this.$props.load();
    if (load === "eager") {
      requestAnimationFrame(this.ga);
    } else if (load === "idle") {
      const { waitIdlePeriod } = await import('maverick.js/std');
      waitIdlePeriod(this.ga);
    } else if (load === "visible") {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          this.ga();
        }
      });
      observer.observe(el);
      return observer.disconnect.bind(observer);
    }
  }
};
var MediaPlayerDelegate = class {
  constructor(_handle, _media) {
    this.M = _handle;
    this.a = _media;
  }
  d(type, ...init) {
    this.M(new DOMEvent(type, init?.[0]));
  }
  async Zc(info, trigger) {
    const { $store, logger } = this.a;
    if (peek($store.canPlay))
      return;
    this.d("can-play", { detail: info, trigger });
    tick();
    if ($store.canPlay() && $store.autoplay() && !$store.started()) {
      await this.gf();
    }
  }
  async gf() {
    const { player, $store } = this.a;
    $store.autoplaying.set(true);
    try {
      await player.play();
      this.d("autoplay", { detail: { muted: $store.muted() } });
    } catch (error) {
      this.d("autoplay-fail", {
        detail: {
          muted: $store.muted(),
          error
        }
      });
    } finally {
      $store.autoplaying.set(false);
    }
  }
};

// src/foundation/queue/queue.ts
var Queue = class {
  constructor() {
    this.f = /* @__PURE__ */ new Map();
  }
  /**
   * Queue the given `item` under the given `key` to be processed at a later time by calling
   * `serve(key)`.
   */
  l(key2, item) {
    if (!this.f.has(key2))
      this.f.set(key2, /* @__PURE__ */ new Set());
    this.f.get(key2).add(item);
  }
  /**
   * Process all items in queue for the given `key`.
   */
  Ib(key2, callback) {
    const items = this.f.get(key2);
    if (items)
      for (const item of items)
        callback(item);
    this.f.delete(key2);
  }
  /**
   * Removes all queued items under the given `key`.
   */
  jd(key2) {
    this.f.delete(key2);
  }
  /**
   * The number of items currently queued under the given `key`.
   */
  me(key2) {
    return this.f.get(key2)?.size ?? 0;
  }
  /**
   * Clear all items in the queue.
   */
  ne() {
    this.f.clear();
  }
};

// src/player/core/state/media-request-manager.ts
var MediaRequestContext = class {
  constructor() {
    this.aa = false;
    this.ba = false;
    this.Ba = false;
    this.f = new Queue();
  }
};
var MediaRequestManager = class extends ComponentController {
  constructor(instance, _stateMgr, _request, _media) {
    super(instance);
    this.N = _stateMgr;
    this.e = _request;
    this.a = _media;
    this.ac = false;
    this.b = _media.$store;
    this.i = _media.$provider;
    this.lb = new MediaUserController(instance);
    this.Ca = new FullscreenController(instance);
    this.D = new ScreenOrientationController(instance);
  }
  onConnect() {
    effect(this.kf.bind(this));
    effect(this.lf.bind(this));
    effect(this.mf.bind(this));
    const names = Object.getOwnPropertyNames(Object.getPrototypeOf(this)), handle = this.nf.bind(this);
    for (const name of names) {
      if (name.startsWith("media-")) {
        this.listen(name, handle);
      }
    }
  }
  nf(event) {
    event.stopPropagation();
    if (peek(this.i))
      this[event.type]?.(event);
  }
  async $b() {
    const { canPlay, paused, ended, autoplaying, seekableStart } = this.b;
    if (!peek(paused))
      return;
    try {
      const provider = peek(this.i);
      throwIfNotReadyForPlayback(provider, peek(canPlay));
      if (peek(ended)) {
        provider.currentTime = seekableStart() + 0.1;
      }
      return provider.play();
    } catch (error) {
      const errorEvent = this.createEvent("play-fail", { detail: coerceToError(error) });
      errorEvent.autoplay = autoplaying();
      this.N.M(errorEvent);
      throw error;
    }
  }
  async kd() {
    const { canPlay, paused } = this.b;
    if (peek(paused))
      return;
    const provider = peek(this.i);
    throwIfNotReadyForPlayback(provider, peek(canPlay));
    return provider.pause();
  }
  ld() {
    const { canPlay, live, liveEdge, canSeek, liveSyncPosition, seekableEnd, userBehindLiveEdge } = this.b;
    userBehindLiveEdge.set(false);
    if (peek(() => !live() || liveEdge() || !canSeek()))
      return;
    const provider = peek(this.i);
    throwIfNotReadyForPlayback(provider, peek(canPlay));
    provider.currentTime = liveSyncPosition() ?? seekableEnd() - 2;
  }
  async md(target = "prefer-media") {
    const provider = peek(this.i);
    const adapter = target === "prefer-media" && this.Ca.supported || target === "media" ? this.Ca : provider?.fullscreen;
    throwIfFullscreenNotSupported(target, adapter);
    if (adapter.active)
      return;
    if (peek(this.b.pictureInPicture)) {
      this.ac = true;
      await this.bc();
    }
    const lockType = peek(this.$props.fullscreenOrientation);
    if (this.D.supported && !isUndefined(lockType)) {
      await this.D.lock(lockType);
    }
    return adapter.enter();
  }
  async nd(target = "prefer-media") {
    const provider = peek(this.i);
    const adapter = target === "prefer-media" && this.Ca.supported || target === "media" ? this.Ca : provider?.fullscreen;
    throwIfFullscreenNotSupported(target, adapter);
    if (!adapter.active)
      return;
    if (this.D.locked)
      await this.D.unlock();
    try {
      const result = await adapter.exit();
      if (this.ac && peek(this.b.canPictureInPicture)) {
        await this.cc();
      }
      return result;
    } finally {
      this.ac = false;
    }
  }
  async cc() {
    this.od();
    if (this.b.pictureInPicture())
      return;
    return await this.i().pictureInPicture.enter();
  }
  async bc() {
    this.od();
    if (!this.b.pictureInPicture())
      return;
    return await this.i().pictureInPicture.exit();
  }
  od() {
    if (this.b.canPictureInPicture())
      return;
    throw Error(
      "[vidstack] no pip support"
    );
  }
  kf() {
    this.lb.idleDelay = this.$props.userIdleDelay();
  }
  lf() {
    const { canLoad, canFullscreen: canFullscreen2 } = this.b, supported = this.Ca.supported || this.i()?.fullscreen?.supported || false;
    if (canLoad() && peek(canFullscreen2) === supported)
      return;
    canFullscreen2.set(supported);
  }
  mf() {
    const { canLoad, canPictureInPicture } = this.b, supported = this.i()?.pictureInPicture?.supported || false;
    if (canLoad() && peek(canPictureInPicture) === supported)
      return;
    canPictureInPicture.set(supported);
  }
  ["media-audio-track-change-request"](event) {
    if (this.a.audioTracks.readonly) {
      return;
    }
    const index = event.detail, track = this.a.audioTracks[index];
    if (track) {
      this.e.f.l("audioTrack", event);
      track.selected = true;
    }
  }
  async ["media-enter-fullscreen-request"](event) {
    try {
      this.e.f.l("fullscreen", event);
      await this.md(event.detail);
    } catch (error) {
      this.cb(error);
    }
  }
  async ["media-exit-fullscreen-request"](event) {
    try {
      this.e.f.l("fullscreen", event);
      await this.nd(event.detail);
    } catch (error) {
      this.cb(error);
    }
  }
  cb(error) {
    this.N.M(
      this.createEvent("fullscreen-error", {
        detail: coerceToError(error)
      })
    );
  }
  async ["media-enter-pip-request"](event) {
    try {
      this.e.f.l("pip", event);
      await this.cc();
    } catch (error) {
      this.pd(error);
    }
  }
  async ["media-exit-pip-request"](event) {
    try {
      this.e.f.l("pip", event);
      await this.bc();
    } catch (error) {
      this.pd(error);
    }
  }
  pd(error) {
    this.N.M(
      this.createEvent("picture-in-picture-error", {
        detail: coerceToError(error)
      })
    );
  }
  ["media-show-poster-request"]() {
    this.b.canLoadPoster.set(true);
  }
  ["media-hide-poster-request"]() {
    this.b.canLoadPoster.set(false);
  }
  ["media-live-edge-request"](event) {
    const { live, liveEdge, canSeek } = this.b;
    if (!live() || liveEdge() || !canSeek())
      return;
    this.e.f.l("seeked", event);
    try {
      this.ld();
    } catch (e) {
    }
  }
  ["media-loop-request"]() {
    window.requestAnimationFrame(async () => {
      try {
        this.e.ba = true;
        this.e.Ba = true;
        await this.$b();
      } catch (e) {
        this.e.ba = false;
        this.e.Ba = false;
      }
    });
  }
  async ["media-pause-request"](event) {
    if (this.b.paused())
      return;
    try {
      this.e.f.l("pause", event);
      await this.i().pause();
    } catch (e) {
      this.e.f.jd("pause");
    }
  }
  async ["media-play-request"](event) {
    if (!this.b.paused())
      return;
    try {
      this.e.f.l("play", event);
      await this.i().play();
    } catch (e) {
      const errorEvent = this.createEvent("play-fail", { detail: coerceToError(e) });
      this.N.M(errorEvent);
    }
  }
  ["media-rate-change-request"](event) {
    if (this.b.playbackRate() === event.detail)
      return;
    this.e.f.l("rate", event);
    this.i().playbackRate = event.detail;
  }
  ["media-quality-change-request"](event) {
    if (this.a.qualities.readonly) {
      return;
    }
    this.e.f.l("quality", event);
    const index = event.detail;
    if (index < 0) {
      this.a.qualities.autoSelect(event);
    } else {
      const quality = this.a.qualities[index];
      if (quality) {
        quality.selected = true;
      }
    }
  }
  ["media-resume-user-idle-request"](event) {
    this.e.f.l("userIdle", event);
    this.lb.idlePaused = false;
  }
  ["media-pause-user-idle-request"](event) {
    this.e.f.l("userIdle", event);
    this.lb.idlePaused = true;
  }
  ["media-seek-request"](event) {
    const { seekableStart, seekableEnd, ended, canSeek, live, userBehindLiveEdge } = this.b;
    if (ended())
      this.e.Ba = true;
    this.e.aa = false;
    this.e.f.jd("seeking");
    const boundTime = Math.min(Math.max(seekableStart() + 0.1, event.detail), seekableEnd() - 0.1);
    if (!Number.isFinite(boundTime) || !canSeek())
      return;
    this.e.f.l("seeked", event);
    this.i().currentTime = boundTime;
    if (live() && event.isOriginTrusted && Math.abs(seekableEnd() - boundTime) >= 2) {
      userBehindLiveEdge.set(true);
    }
  }
  ["media-seeking-request"](event) {
    this.e.f.l("seeking", event);
    this.b.seeking.set(true);
    this.e.aa = true;
  }
  ["media-start-loading"](event) {
    if (this.b.canLoad())
      return;
    this.e.f.l("load", event);
    this.N.M(this.createEvent("can-load"));
  }
  ["media-text-track-change-request"](event) {
    const { index, mode } = event.detail, track = this.a.textTracks[index];
    if (track) {
      this.e.f.l("textTrack", event);
      track.setMode(mode, event);
    }
  }
  ["media-mute-request"](event) {
    if (this.b.muted())
      return;
    this.e.f.l("volume", event);
    this.i().muted = true;
  }
  ["media-unmute-request"](event) {
    const { muted, volume } = this.b;
    if (!muted())
      return;
    this.e.f.l("volume", event);
    this.a.$provider().muted = false;
    if (volume() === 0) {
      this.e.f.l("volume", event);
      this.i().volume = 0.25;
    }
  }
  ["media-volume-change-request"](event) {
    const { muted, volume } = this.b;
    const newVolume = event.detail;
    if (volume() === newVolume)
      return;
    this.e.f.l("volume", event);
    this.i().volume = newVolume;
    if (newVolume > 0 && muted()) {
      this.e.f.l("volume", event);
      this.i().muted = false;
    }
  }
};
function throwIfNotReadyForPlayback(provider, canPlay) {
  if (provider && canPlay)
    return;
  throw Error(
    "[vidstack] media not ready"
  );
}
function throwIfFullscreenNotSupported(target, fullscreen) {
  if (fullscreen?.supported)
    return;
  throw Error(
    "[vidstack] no fullscreen support"
  );
}

// ../../node_modules/.pnpm/just-debounce-it@3.2.0/node_modules/just-debounce-it/index.mjs
var functionDebounce = debounce;
function debounce(fn, wait, callFirst) {
  var timeout = null;
  var debouncedFn = null;
  var clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      debouncedFn = null;
      timeout = null;
    }
  };
  var flush = function() {
    var call = debouncedFn;
    clear();
    if (call) {
      call();
    }
  };
  var debounceWrapper = function() {
    if (!wait) {
      return fn.apply(this, arguments);
    }
    var context = this;
    var args = arguments;
    var callNow = callFirst && !timeout;
    clear();
    debouncedFn = function() {
      fn.apply(context, args);
    };
    timeout = setTimeout(function() {
      timeout = null;
      if (!callNow) {
        var call = debouncedFn;
        debouncedFn = null;
        return call();
      }
    }, wait);
    if (callNow) {
      return debouncedFn();
    }
  };
  debounceWrapper.cancel = clear;
  debounceWrapper.flush = flush;
  return debounceWrapper;
}

// src/player/core/state/tracked-media-events.ts
var TRACKED_EVENT = /* @__PURE__ */ new Set([
  "autoplay",
  "autoplay-fail",
  "can-load",
  "sources-change",
  "source-change",
  "load-start",
  "abort",
  "error",
  "loaded-metadata",
  "loaded-data",
  "can-play",
  "play",
  "play-fail",
  "pause",
  "playing",
  "seeking",
  "seeked",
  "waiting"
]);

// src/player/core/state/media-state-manager.ts
var MediaStateManager = class extends ComponentController {
  constructor(instance, _request, _media) {
    super(instance);
    this.e = _request;
    this.a = _media;
    this.n = /* @__PURE__ */ new Map();
    this.qd = true;
    this.mb = false;
    this["seeking"] = functionThrottle(
      (event) => {
        const { seeking, currentTime, paused } = this.b;
        seeking.set(true);
        currentTime.set(event.detail);
        this.A("seeking", event);
        if (paused()) {
          this.Da = event;
          this.ec();
        }
      },
      150,
      { leading: true }
    );
    this.ec = functionDebounce(() => {
      if (!this.Da)
        return;
      this.mb = true;
      const { waiting, playing } = this.b;
      waiting.set(true);
      playing.set(false);
      const event = this.createEvent("waiting", { trigger: this.Da });
      this.n.set("waiting", event);
      this.el.dispatchEvent(event);
      this.Da = void 0;
      this.mb = false;
    }, 300);
    this.b = _media.$store;
  }
  onAttach(el) {
    el.setAttribute("aria-busy", "true");
  }
  onConnect(el) {
    this.of();
    this.pf();
    this.qf();
    this.listen("fullscreen-change", this["fullscreen-change"].bind(this));
    this.listen("fullscreen-error", this["fullscreen-error"].bind(this));
  }
  M(event) {
    const type = event.type;
    this[event.type]?.(event);
    {
      if (TRACKED_EVENT.has(type))
        this.n.set(type, event);
      this.el?.dispatchEvent(event);
    }
  }
  Ea() {
    this.rd();
    this.e.Ba = false;
    this.e.ba = false;
    this.mb = false;
    this.Da = void 0;
    this.n.clear();
  }
  A(request, event) {
    this.e.f.Ib(request, (requestEvent) => {
      event.request = requestEvent;
      appendTriggerEvent(event, requestEvent);
    });
  }
  of() {
    this.dc();
    this.sd();
    const textTracks = this.a.textTracks;
    listenEvent(textTracks, "add", this.dc.bind(this));
    listenEvent(textTracks, "remove", this.dc.bind(this));
    listenEvent(textTracks, "mode-change", this.sd.bind(this));
  }
  pf() {
    const qualities = this.a.qualities;
    listenEvent(qualities, "add", this.td.bind(this));
    listenEvent(qualities, "remove", this.td.bind(this));
    listenEvent(qualities, "change", this.Qb.bind(this));
    listenEvent(qualities, "auto-change", this.rf.bind(this));
    listenEvent(qualities, "readonly-change", this.sf.bind(this));
  }
  qf() {
    const audioTracks = this.a.audioTracks;
    listenEvent(audioTracks, "add", this.ud.bind(this));
    listenEvent(audioTracks, "remove", this.ud.bind(this));
    listenEvent(audioTracks, "change", this.tf.bind(this));
  }
  dc(event) {
    const { textTracks } = this.b;
    textTracks.set(this.a.textTracks.toArray());
    this.dispatch("text-tracks-change", {
      detail: textTracks(),
      trigger: event
    });
  }
  sd(event) {
    if (event)
      this.A("textTrack", event);
    const current = this.a.textTracks.selected, { textTrack } = this.b;
    if (textTrack() !== current) {
      textTrack.set(current);
      this.dispatch("text-track-change", {
        detail: current,
        trigger: event
      });
    }
  }
  ud(event) {
    const { audioTracks } = this.b;
    audioTracks.set(this.a.audioTracks.toArray());
    this.dispatch("audio-tracks-change", {
      detail: audioTracks(),
      trigger: event
    });
  }
  tf(event) {
    const { audioTrack } = this.b;
    audioTrack.set(this.a.audioTracks.selected);
    this.A("audioTrack", event);
    this.dispatch("audio-track-change", {
      detail: audioTrack(),
      trigger: event
    });
  }
  td(event) {
    const { qualities } = this.b;
    qualities.set(this.a.qualities.toArray());
    this.dispatch("qualities-change", {
      detail: qualities(),
      trigger: event
    });
  }
  Qb(event) {
    const { quality } = this.b;
    quality.set(this.a.qualities.selected);
    this.A("quality", event);
    this.dispatch("quality-change", {
      detail: quality(),
      trigger: event
    });
  }
  rf() {
    this.b.autoQuality.set(this.a.qualities.auto);
  }
  sf() {
    this.b.canSetQuality.set(!this.a.qualities.readonly);
  }
  ["provider-change"](event) {
    this.a.$provider.set(event.detail);
  }
  ["autoplay"](event) {
    appendTriggerEvent(event, this.n.get("play"));
    appendTriggerEvent(event, this.n.get("can-play"));
    this.b.autoplayError.set(void 0);
  }
  ["autoplay-fail"](event) {
    appendTriggerEvent(event, this.n.get("play-fail"));
    appendTriggerEvent(event, this.n.get("can-play"));
    this.b.autoplayError.set(event.detail);
    this.Ea();
  }
  ["can-load"](event) {
    this.b.canLoad.set(true);
    this.n.set("can-load", event);
    this.A("load", event);
    this.a.textTracks[TEXT_TRACK_CAN_LOAD]();
  }
  ["media-type-change"](event) {
    appendTriggerEvent(event, this.n.get("source-change"));
    const viewType = this.b.viewType();
    this.b.mediaType.set(event.detail);
    if (viewType !== this.b.viewType()) {
      setTimeout(
        () => this.dispatch("view-type-change", {
          detail: this.b.viewType(),
          trigger: event
        }),
        0
      );
    }
  }
  ["stream-type-change"](event) {
    const { streamType, inferredStreamType } = this.b;
    appendTriggerEvent(event, this.n.get("source-change"));
    inferredStreamType.set(event.detail);
    event.detail = streamType();
  }
  ["rate-change"](event) {
    this.b.playbackRate.set(event.detail);
    this.A("rate", event);
  }
  ["sources-change"](event) {
    this.b.sources.set(event.detail);
  }
  ["source-change"](event) {
    appendTriggerEvent(event, this.n.get("sources-change"));
    this.b.source.set(event.detail);
    this.el?.setAttribute("aria-busy", "true");
    if (this.qd) {
      this.qd = false;
      return;
    }
    this.a.audioTracks[LIST_RESET](event);
    this.a.qualities[LIST_RESET](event);
    this.Ea();
    softResetMediaStore(this.a.$store);
    this.n.set(event.type, event);
  }
  ["abort"](event) {
    appendTriggerEvent(event, this.n.get("source-change"));
    appendTriggerEvent(event, this.n.get("can-load"));
  }
  ["load-start"](event) {
    appendTriggerEvent(event, this.n.get("source-change"));
  }
  ["error"](event) {
    this.b.error.set(event.detail);
    appendTriggerEvent(event, this.n.get("abort"));
  }
  ["loaded-metadata"](event) {
    appendTriggerEvent(event, this.n.get("load-start"));
  }
  ["loaded-data"](event) {
    appendTriggerEvent(event, this.n.get("load-start"));
  }
  ["can-play"](event) {
    if (event.trigger?.type !== "loadedmetadata") {
      appendTriggerEvent(event, this.n.get("loaded-metadata"));
    }
    this.vd(event.detail);
    this.el?.setAttribute("aria-busy", "false");
  }
  ["can-play-through"](event) {
    this.vd(event.detail);
    appendTriggerEvent(event, this.n.get("can-play"));
  }
  vd(detail) {
    const { seekable, seekableEnd, buffered, duration, canPlay } = this.b;
    seekable.set(detail.seekable);
    buffered.set(detail.buffered);
    duration.set(seekableEnd);
    canPlay.set(true);
  }
  ["duration-change"](event) {
    const { live, duration } = this.b, time = event.detail;
    if (!live())
      duration.set(!Number.isNaN(time) ? time : 0);
  }
  ["progress"](event) {
    const { buffered, seekable, live, duration, seekableEnd } = this.b, detail = event.detail;
    buffered.set(detail.buffered);
    seekable.set(detail.seekable);
    if (live()) {
      duration.set(seekableEnd);
      this.dispatch("duration-change", {
        detail: seekableEnd(),
        trigger: event
      });
    }
  }
  ["play"](event) {
    const { paused, autoplayError, ended, autoplaying } = this.b;
    event.autoplay = autoplaying();
    if (this.e.ba || !paused()) {
      event.stopImmediatePropagation();
      return;
    }
    appendTriggerEvent(event, this.n.get("waiting"));
    this.A("play", event);
    paused.set(false);
    autoplayError.set(void 0);
    if (ended() || this.e.Ba) {
      this.e.Ba = false;
      ended.set(false);
      this.M(this.createEvent("replay", { trigger: event }));
    }
  }
  ["play-fail"](event) {
    appendTriggerEvent(event, this.n.get("play"));
    this.A("play", event);
    const { paused, playing } = this.b;
    paused.set(true);
    playing.set(false);
    this.Ea();
  }
  ["playing"](event) {
    const playEvent = this.n.get("play");
    if (playEvent) {
      appendTriggerEvent(event, this.n.get("waiting"));
      appendTriggerEvent(event, playEvent);
    } else {
      appendTriggerEvent(event, this.n.get("seeked"));
    }
    setTimeout(() => this.Ea(), 0);
    const { paused, playing, seeking, ended } = this.b;
    paused.set(false);
    playing.set(true);
    seeking.set(false);
    ended.set(false);
    if (this.e.ba) {
      event.stopImmediatePropagation();
      this.e.ba = false;
      return;
    }
    this["started"](event);
  }
  ["started"](event) {
    const { started, live, liveSyncPosition, seekableEnd } = this.b;
    if (!started()) {
      if (live()) {
        const end = liveSyncPosition() ?? seekableEnd() - 2;
        if (Number.isFinite(end))
          this.a.$provider().currentTime = end;
      }
      started.set(true);
      this.M(this.createEvent("started", { trigger: event }));
    }
  }
  ["pause"](event) {
    if (this.e.ba) {
      event.stopImmediatePropagation();
      return;
    }
    appendTriggerEvent(event, this.n.get("seeked"));
    this.A("pause", event);
    const { paused, playing, seeking } = this.b;
    paused.set(true);
    playing.set(false);
    seeking.set(false);
    this.Ea();
  }
  ["time-update"](event) {
    const { currentTime, played, waiting } = this.b, detail = event.detail;
    currentTime.set(detail.currentTime);
    played.set(detail.played);
    waiting.set(false);
    for (const track of this.a.textTracks) {
      if (track.mode === "disabled")
        continue;
      track[TEXT_TRACK_UPDATE_ACTIVE_CUES](detail.currentTime, event);
    }
  }
  ["volume-change"](event) {
    const { volume, muted } = this.b, detail = event.detail;
    volume.set(detail.volume);
    muted.set(detail.muted || detail.volume === 0);
    this.A("volume", event);
  }
  ["seeked"](event) {
    const { seeking, currentTime, paused, duration, ended } = this.b;
    if (this.e.aa) {
      seeking.set(true);
      event.stopImmediatePropagation();
    } else if (seeking()) {
      const waitingEvent = this.n.get("waiting");
      appendTriggerEvent(event, waitingEvent);
      if (waitingEvent?.trigger?.type !== "seeking") {
        appendTriggerEvent(event, this.n.get("seeking"));
      }
      if (paused())
        this.rd();
      seeking.set(false);
      if (event.detail !== duration())
        ended.set(false);
      currentTime.set(event.detail);
      this.A("seeked", event);
      const origin = event.originEvent;
      if (origin && origin.isTrusted && !/seek/.test(origin.type)) {
        this["started"](event);
      }
    }
  }
  ["waiting"](event) {
    if (this.mb || this.e.aa)
      return;
    event.stopImmediatePropagation();
    this.Da = event;
    this.ec();
  }
  ["ended"](event) {
    if (this.e.ba) {
      event.stopImmediatePropagation();
      return;
    }
    const { paused, playing, seeking, ended } = this.b;
    paused.set(true);
    playing.set(false);
    seeking.set(false);
    ended.set(true);
    this.Ea();
  }
  rd() {
    this.ec.cancel();
    this.b.waiting.set(false);
  }
  ["fullscreen-change"](event) {
    this.b.fullscreen.set(event.detail);
    this.A("fullscreen", event);
  }
  ["fullscreen-error"](event) {
    this.A("fullscreen", event);
  }
  ["picture-in-picture-change"](event) {
    this.b.pictureInPicture.set(event.detail);
    this.A("pip", event);
  }
  ["picture-in-picture-error"](event) {
    this.A("pip", event);
  }
};
var MediaStoreSync = class extends ComponentController {
  onAttach(el) {
    effect(this.uf.bind(this));
    effect(this.vf.bind(this));
    effect(this.wf.bind(this));
    effect(this.xf.bind(this));
    effect(this.yf.bind(this));
    effect(this.zf.bind(this));
    effect(this.Af.bind(this));
    effect(this.Bf.bind(this));
    effect(this.Cf.bind(this));
    effect(this.Df.bind(this));
    effect(this.Ef.bind(this));
  }
  Hh() {
    return;
  }
  uf() {
    const autoplay = this.$props.autoplay();
    this.$store.autoplay.set(autoplay);
    this.dispatch("autoplay-change", { detail: autoplay });
  }
  wf() {
    const loop = this.$props.loop();
    this.$store.loop.set(loop);
    this.dispatch("loop-change", { detail: loop });
  }
  xf() {
    const controls = this.$props.controls();
    this.$store.controls.set(controls);
    this.dispatch("controls-change", { detail: controls });
  }
  vf() {
    const poster = this.$props.poster();
    this.$store.poster.set(poster);
    this.dispatch("poster-change", { detail: poster });
  }
  yf() {
    this.$store.crossorigin.set(this.$props.crossorigin());
  }
  zf() {
    const playsinline = this.$props.playsinline();
    this.$store.playsinline.set(playsinline);
    this.dispatch("playsinline-change", { detail: playsinline });
  }
  Bf() {
    this.dispatch("live-change", { detail: this.$store.live() });
  }
  Af() {
    this.$store.liveEdgeTolerance.set(this.$props.liveEdgeTolerance());
    this.$store.minLiveDVRWindow.set(this.$props.minLiveDVRWindow());
  }
  Cf() {
    this.dispatch("live-edge-change", { detail: this.$store.liveEdge() });
  }
  Df() {
    this.$store.thumbnails.set(this.$props.thumbnails());
  }
  Ef() {
    this.$store.title.set(this.$props.title());
  }
};
var ThumbnailsLoader = class extends ComponentController {
  onConnect() {
    this.a = useMedia();
    effect(this.Ff.bind(this));
  }
  Ff() {
    const { canLoad, thumbnailCues } = this.a.$store;
    if (!canLoad())
      return;
    const controller = new AbortController(), { crossorigin, thumbnails } = this.a.$store;
    const src = thumbnails();
    if (!src)
      return;
    parseResponse(
      fetch(src, {
        signal: controller.signal,
        credentials: getRequestCredentials(crossorigin())
      })
    ).then(({ cues }) => thumbnailCues.set(cues)).catch(noop);
    return () => {
      controller.abort();
      thumbnailCues.set([]);
    };
  }
};

// src/player/core/player.tsx
var Player = class extends Component {
  constructor(instance) {
    super(instance);
    this.T = new RequestQueue();
    this.Mf();
    new MediaStoreSync(instance);
    const context = {
      player: null,
      qualities: new VideoQualityList(),
      audioTracks: new AudioTrackList(),
      $provider: signal(null),
      $props: this.$props,
      $store: this.$store
    };
    context.remote = new MediaRemoteControl(void 0);
    context.$iosControls = computed(this.Nf.bind(this));
    context.textTracks = new TextTrackList();
    context.textTracks[TEXT_TRACK_CROSSORIGIN] = this.$props.crossorigin;
    context.textRenderers = new TextRenderers(context);
    context.ariaKeys = {};
    this.a = context;
    provideContext(mediaContext, context);
    this.user = new MediaUserController(instance);
    this.orientation = new ScreenOrientationController(instance);
    new FocusVisibleController(instance);
    new MediaKeyboardController(instance, context);
    new ThumbnailsLoader(instance);
    const request = new MediaRequestContext();
    this.N = new MediaStateManager(instance, request, context);
    this.P = new MediaRequestManager(instance, this.N, request, context);
    context.delegate = new MediaPlayerDelegate(
      this.N.M.bind(this.N),
      context
    );
    effect(this.Of.bind(this));
    effect(this.Pf.bind(this));
    effect(this._b.bind(this));
    effect(this.hc.bind(this));
    effect(this.Ya.bind(this));
    effect(this.Qf.bind(this));
    effect(this.Rf.bind(this));
    new MediaLoadController(instance, this.startLoading.bind(this));
  }
  get i() {
    return this.a.$provider();
  }
  onAttach(el) {
    el.setAttribute("tabindex", "0");
    setAttributeIfEmpty(el, "role", "region");
    effect(this.Sf.bind(this));
    this.Tf();
    this.Uf();
    this.a.player = el;
    this.a.remote.setTarget(el);
    this.a.remote.setPlayer(el);
    listenEvent(el, "find-media-player", this.Vf.bind(this));
  }
  onConnect(el) {
    this.dispatch("media-player-connect", {
      detail: this.el,
      bubbles: true,
      composed: true
    });
    window.requestAnimationFrame(() => {
      if (isNull(this.$store.canLoadPoster())) {
        this.$store.canLoadPoster.set(true);
      }
    });
  }
  Mf() {
    const providedProps = {
      viewType: "providedViewType",
      streamType: "providedStreamType"
    };
    for (const prop2 of Object.keys(this.$props)) {
      this.$store[providedProps[prop2] ?? prop2]?.set(this.$props[prop2]());
    }
    effect(this.Wf.bind(this));
    this.$store.muted.set(this.$props.muted() || this.$props.volume() === 0);
  }
  Sf() {
    const { title, live, viewType } = this.$store, isLive = live(), type = uppercaseFirstChar(viewType()), typeText = type !== "Unknown" ? `${isLive ? "Live " : ""}${type}` : isLive ? "Live" : "Media";
    setAttribute(
      this.el,
      "aria-label",
      title() ? `${typeText} - ${title()}` : typeText + " Player"
    );
  }
  Of() {
    if (this.$store.canPlay() && this.i)
      this.T.eb();
    else
      this.T.fa();
  }
  Wf() {
    this.$store.providedViewType.set(this.$props.viewType());
    this.$store.providedStreamType.set(this.$props.streamType());
  }
  Tf() {
    const $attrs = {
      "aspect-ratio": this.$props.aspectRatio,
      "data-captions": () => {
        const track = this.$store.textTrack();
        return !!track && isTrackCaptionKind(track);
      },
      "data-ios-controls": this.a.$iosControls
    };
    const mediaAttrName = {
      canPictureInPicture: "can-pip",
      pictureInPicture: "pip"
    };
    for (const prop2 of MEDIA_ATTRIBUTES) {
      const attrName = "data-" + (mediaAttrName[prop2] ?? camelToKebabCase(prop2));
      $attrs[attrName] = this.$store[prop2];
    }
    this.setAttributes($attrs);
  }
  Uf() {
    this.setCSSVars({
      "--media-aspect-ratio": () => {
        const ratio = this.$props.aspectRatio();
        return ratio ? +ratio.toFixed(4) : null;
      },
      "--media-buffered": () => +this.$store.bufferedEnd().toFixed(3),
      "--media-current-time": () => +this.$store.currentTime().toFixed(3),
      "--media-duration": () => {
        const duration = this.$store.duration();
        return Number.isFinite(duration) ? +duration.toFixed(3) : 0;
      }
    });
  }
  Vf(event) {
    event.detail(this.el);
  }
  Nf() {
    return !canFullscreen() && this.$store.mediaType() === "video" && (this.$store.controls() && !this.$props.playsinline() || this.$store.fullscreen());
  }
  get provider() {
    return this.i;
  }
  get qualities() {
    return this.a.qualities;
  }
  get audioTracks() {
    return this.a.audioTracks;
  }
  get textTracks() {
    return this.a.textTracks;
  }
  get textRenderers() {
    return this.a.textRenderers;
  }
  get paused() {
    return this.i?.paused ?? true;
  }
  set paused(paused) {
    if (paused) {
      this.T.l("paused", () => this.P.kd());
    } else
      this.T.l("paused", () => this.P.$b());
  }
  _b() {
    this.paused = this.$props.paused();
  }
  get muted() {
    return this.i?.muted ?? false;
  }
  set muted(muted) {
    this.T.l("muted", () => this.i.muted = muted);
  }
  Pf() {
    this.muted = this.$props.muted();
  }
  get currentTime() {
    return this.i?.currentTime ?? 0;
  }
  set currentTime(time) {
    this.T.l("currentTime", () => {
      const adapter = this.i;
      if (time !== adapter.currentTime) {
        peek(() => {
          const boundTime = Math.min(
            Math.max(this.$store.seekableStart() + 0.1, time),
            this.$store.seekableEnd() - 0.1
          );
          if (Number.isFinite(boundTime))
            adapter.currentTime = boundTime;
        });
      }
    });
  }
  Ya() {
    this.currentTime = this.$props.currentTime();
  }
  get volume() {
    return this.i?.volume ?? 1;
  }
  set volume(volume) {
    this.T.l("volume", () => this.i.volume = volume);
  }
  hc() {
    this.volume = clampNumber(0, this.$props.volume(), 1);
  }
  get playsinline() {
    return this.i?.playsinline ?? false;
  }
  set playsinline(inline) {
    this.T.l("playsinline", () => this.i.playsinline = inline);
  }
  Qf() {
    this.playsinline = this.$props.playsinline();
  }
  get playbackRate() {
    return this.i?.playbackRate ?? 1;
  }
  set playbackRate(rate) {
    this.T.l("rate", () => this.i.playbackRate = rate);
  }
  Rf() {
    this.playbackRate = this.$props.playbackRate();
  }
  async play() {
    return this.P.$b();
  }
  async pause() {
    return this.P.kd();
  }
  async enterFullscreen(target) {
    return this.P.md(target);
  }
  async exitFullscreen(target) {
    return this.P.nd(target);
  }
  enterPictureInPicture() {
    return this.P.cc();
  }
  exitPictureInPicture() {
    return this.P.bc();
  }
  seekToLiveEdge() {
    this.P.ld();
  }
  startLoading() {
    this.a.delegate.d("can-load");
  }
  destroy() {
    this.dispatch("destroy");
  }
};
Player.el = defineElement({
  tagName: "media-player",
  props: mediaPlayerProps,
  store: MediaStoreFactory
});
__decorateClass([
  prop
], Player.prototype, "provider", 1);
__decorateClass([
  prop
], Player.prototype, "user", 2);
__decorateClass([
  prop
], Player.prototype, "orientation", 2);
__decorateClass([
  prop
], Player.prototype, "qualities", 1);
__decorateClass([
  prop
], Player.prototype, "audioTracks", 1);
__decorateClass([
  prop
], Player.prototype, "textTracks", 1);
__decorateClass([
  prop
], Player.prototype, "textRenderers", 1);
__decorateClass([
  prop
], Player.prototype, "paused", 1);
__decorateClass([
  prop
], Player.prototype, "muted", 1);
__decorateClass([
  prop
], Player.prototype, "currentTime", 1);
__decorateClass([
  prop
], Player.prototype, "volume", 1);
__decorateClass([
  prop
], Player.prototype, "playsinline", 1);
__decorateClass([
  prop
], Player.prototype, "playbackRate", 1);
__decorateClass([
  method
], Player.prototype, "play", 1);
__decorateClass([
  method
], Player.prototype, "pause", 1);
__decorateClass([
  method
], Player.prototype, "enterFullscreen", 1);
__decorateClass([
  method
], Player.prototype, "exitFullscreen", 1);
__decorateClass([
  method
], Player.prototype, "enterPictureInPicture", 1);
__decorateClass([
  method
], Player.prototype, "exitPictureInPicture", 1);
__decorateClass([
  method
], Player.prototype, "seekToLiveEdge", 1);
__decorateClass([
  method
], Player.prototype, "startLoading", 1);

export { AudioTrackList, FullscreenController, List, MEDIA_KEY_SHORTCUTS, MediaRemoteControl, MediaStoreFactory, MediaUserController, Player, ScreenOrientationController, TextRenderers, TextTrackList, TimeRange, VideoQualityList, canFullscreen, getTimeRangesEnd, getTimeRangesStart, isAudioProvider, isHLSProvider, isHTMLAudioElement, isHTMLMediaElement, isHTMLVideoElement, isVideoProvider, softResetMediaStore };
